export { default } from './outside-click-handler';
